var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import CreatePartial from "./CreatePartial";
var stripePromise = loadStripe(process.env.MIX_STRIPE_KEY);
export default function Create(_a) {
    var intent = _a.intent, stripe_key = _a.stripe_key;
    return _jsx(Elements, __assign({ stripe: stripePromise }, { children: _jsx(CreatePartial, { intent: intent, stripe_key: stripe_key }) }));
}
